/**
 * THE FIVE VIP ACTIONS, ONE COLOUR EACH — loyalty only.
 *
 * Used by the Members list and by the member screen, so the same action wears
 * the same colour and the same icon everywhere. Soft fill, stronger border of
 * the same colour, readable in light AND dark, and 44px tall for an iPad.
 */
import { CalendarCheck, Clock, Gift, KeyRound, Minus, Pencil, Plus } from 'lucide-react';

export const ACTION_STYLE = {
    points: 'bg-emerald-50 border-emerald-400 text-emerald-800 hover:bg-emerald-100 '
        + 'dark:bg-emerald-500/15 dark:border-emerald-400/70 dark:text-emerald-200 '
        + 'dark:hover:bg-emerald-500/25',
    cards: 'bg-amber-50 border-amber-400 text-amber-800 hover:bg-amber-100 '
        + 'dark:bg-amber-400/15 dark:border-amber-400/70 dark:text-amber-200 '
        + 'dark:hover:bg-amber-400/25',
    visit: 'bg-teal-50 border-teal-400 text-teal-800 hover:bg-teal-100 '
        + 'dark:bg-teal-400/15 dark:border-teal-400/70 dark:text-teal-200 '
        + 'dark:hover:bg-teal-400/25',
    pin: 'bg-orange-50 border-orange-400 text-orange-800 hover:bg-orange-100 '
        + 'dark:bg-orange-400/15 dark:border-orange-400/70 dark:text-orange-200 '
        + 'dark:hover:bg-orange-400/25',
    history: 'bg-indigo-50 border-indigo-400 text-indigo-800 hover:bg-indigo-100 '
        + 'dark:bg-indigo-400/15 dark:border-indigo-400/70 dark:text-indigo-200 '
        + 'dark:hover:bg-indigo-400/25',
    name: 'bg-sky-50 border-sky-400 text-sky-800 hover:bg-sky-100 '
        + 'dark:bg-sky-400/15 dark:border-sky-400/70 dark:text-sky-200 '
        + 'dark:hover:bg-sky-400/25',
};

export const ActionIcon = ({ action }) => {
    if (action === 'points') {
        return (
            <span className="flex items-center" aria-hidden="true">
                <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
                <Minus className="-ml-1 h-3.5 w-3.5" strokeWidth={2.5} />
            </span>
        );
    }
    const Icon = { cards: Gift, visit: CalendarCheck, pin: KeyRound, history: Clock,
                   name: Pencil }[action];
    return Icon ? <Icon className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" /> : null;
};

/** One coloured pill. Same label and same behaviour as before — only dressed. */
export const ActionButton = ({ action, label, onClick, disabled = false, testid,
                               className = '' }) => (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={testid}
            className={`inline-flex min-h-[44px] items-center justify-center gap-1.5 rounded-xl
                        border-2 px-3 text-xs font-semibold transition-colors
                        disabled:cursor-not-allowed disabled:opacity-50
                        ${ACTION_STYLE[action]} ${className}`}>
        <ActionIcon action={action} />
        <span>{label}</span>
    </button>
);
